import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { parseAirDateToISO } from "@air/utilities";
import classNames from "classnames";
import { differenceInDays, format, startOfToday } from "__barrel_optimize__?names=differenceInDays,format,startOfToday!=!date-fns";
import pluralize from "pluralize";
import { useMemo } from "react";
export const SharePrivateContentExpirationDateDisplay = (param)=>{
    let { expirationDate, goToAdvancedSettings } = param;
    const date = parseAirDateToISO(expirationDate);
    const difference = differenceInDays(date, startOfToday());
    const text = useMemo(()=>{
        if (difference < 0) return "Link expired on ".concat(format(date, "MMM d, yyyy"), ".");
        return "Link expires ".concat(difference === 0 ? "today." : "in ".concat(pluralize("day", difference, true), "."));
    }, [
        difference,
        date
    ]);
    const textColor = difference < 1 ? "text-red-9" : difference === 1 ? "text-blue-11" : "text-grey-9";
    const hoverColor = difference < 1 ? "hover:text-red-10" : difference === 1 ? "hover:text-blue-12" : "";
    return /*#__PURE__*/ _jsxs("p", {
        className: classNames("text-14", textColor, hoverColor),
        role: "alert",
        children: [
            text,
            /*#__PURE__*/ _jsx("button", {
                onClick: goToAdvancedSettings,
                className: classNames("ml-1 font-semibold", textColor, difference > 1 ? "hover:text-grey-12" : hoverColor),
                children: "Manage expiration date →"
            })
        ]
    });
};
